export const shippingOptions = [
  {
    text: "Label",
    value: "LBL",
    description: "Outbound Label"
  },
  {
    text: "Scan-Based Return Label",
    value: "SBR",
    description: "Scan-Based Return"
  },
  {
    text: "Prepaid Return Label",
    value: "RLBL",
    description: "Prepaid Return"
  },
  {
    text: "Label to PDF",
    value: "LBLPDF",
    description: "Outbound Label in PDF"
  },
  {
    text: "Label + Prepaid Return",
    value: "LBLRLBL",
    description: "Outbound label and prepaid return"
  },
  {
    text: "Label + Scan-Based Return",
    value: "LBLSBR",
    description: "Outbound label and SBR"
  },
  {
    text: "Test Label",
    value: "TSTLBL",
    description: "Outbound test label"
  },
]



// WEBPACK FOOTER //
// ./resources/assets/js/data/shipping-options.js